import Vue from "vue";

Vue.mixin({
	computed: {
		$isBlueBranding() {
			return true;

			// if (process.server) {
			// 	return true;
			// }
			//
			// const store = this.$store;
			// if (!store || !store.state) {
			// 	return true;
			// }
			//
			// if (!store.state.features?.loaded) {
			// 	return true;
			// }
			//
			// return Boolean(this.isFeatureEnabled("BlueBranding"));
		},
	},
});
